/** Native quantity constraints, with explicit stepper boundaries. */
function bounds(field) {
  return { min: Number(field.min) || 1, max: Number(field.max) || 99 };
}

function sync(field, normalize = false) {
  const { min, max } = bounds(field);
  const value = Number.isFinite(Number(field.value)) && field.value !== '' ? Math.trunc(Number(field.value)) : min;
  if (normalize) field.value = Math.max(min, Math.min(max, value));
  const control = field.closest('.tt-qty__c');
  const decrease = control?.querySelector('[data-q="-1"]');
  const increase = control?.querySelector('[data-q="1"]');
  if (decrease) decrease.disabled = value <= min;
  if (increase) increase.disabled = value >= max;
}

document.querySelectorAll('.tt-qty__c input').forEach(field => sync(field));

document.addEventListener('input', (event) => {
  if (event.target.matches('.tt-qty__c input')) sync(event.target);
});

document.addEventListener('change', (event) => {
  if (event.target.matches('.tt-qty__c input')) sync(event.target, true);
});

document.addEventListener('focusout', (event) => {
  if (event.target.matches('.tt-qty__c input')) sync(event.target, true);
});

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-q]');
  if (!button || button.disabled) return;

  const field = button.closest('.tt-qty__c')?.querySelector('input');
  if (!field) return;

  const { min, max } = bounds(field);
  const next = (Number(field.value) || min) + Number(button.dataset.q);

  field.value = Math.max(min, Math.min(max, next));
  sync(field, true);
  field.dispatchEvent(new Event('change', { bubbles: true }));
});
